module.exports = {
  _pathPrefix: "/", // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  _title: "Bourne Digital - Experience matters.", // Navigation and Site Title
  _titleAlt: "Bourne Digital", // Title for JSONLD
  description:
    "Bourne Digital was born in Melbourne, born to innovate and born for cloud. We deliver innovation through agile delivery of cloud solutions including mobile, UX, advanced analytics and Internet of Things solutions. We are passionate about the role of digital innovation in improving productivity and enabling growth for our clients.",
  _url: "https://bournedigital.com.au", // Domain of your site. No trailing slash!
  siteLanguage: "en", // Language Tag on <html> element
  logo: "/logos/logo.png", // Used for SEO

  // JSONLD / Manifest
  favicon: "src/favicon.ico", // Used for manifest favicon generation
  shortName: "Bourne", // shortname for manifest. MUST be shorter than 12 characters
  author: "", // Author for schemaORGJSONLD
  themeColor: "#0066b2",
  backgroundColor: "#EBEDF2",

  twitter: "@bourne_digital" // Twitter Username
};
